export default __webpack_public_path__ + "static/media/ChrisTeters.5616d311.pdf";